export * as actionProvider from '@wix/auto_sdk_automations_action-provider';
export * as triggerProvider from '@wix/auto_sdk_automations_trigger-provider';